import React from "react";
import {connect} from "react-redux";
import AuctionsManager from "@nextlot/core/webcast/services/AuctionsManager";
import type {Bid} from "@nextlot/core/webcast/data/data_types_definitions";
import {CurrencyAmountDisplay} from "../CurrencyAmountDisplay";
import {ReduxActiveWebcastSubStateType} from "@nextlot/core/webcast/redux/reducerActiveWebcast";



function BiddingHistoryListItem(props: { bid: Bid, isHighestBid?: boolean, isMyBid?: boolean, t: any }) {
    return (
        <div className={`bid-history__list-item ${props.bid.overridden ? 'is-overridden' : ''} ${props.isMyBid ? 'is-my-bid' : ''}`}>
            <CurrencyAmountDisplay valueCents={props.bid.value} className="value" />

            <span className="px-2 flex-grow-1">{'\u00bb'}</span>

            <div className="bidder-label-container">
                <span className="bidder">{props.bid.bidderDisplay}</span>
                {props.bid.overridden ? <strong>({props.t('biddingArea.floorFirst')})</strong> : ''}
            </div>

            <div className="list-item-overlay" />
        </div>
    )
}




function BidderBidHistoryCmp(props: { bidsHistory:Array<Bid>, t: any }) {
    const bidsHistory:Array<Bid> = props.bidsHistory;

    const myUserId: number = AuctionsManager.currentWebcastAuctionHandler.myUserId;
    const {t} = props;

    return (
        <div className="bidder-bid-history-outline">
            <div className="bidder-cmp bidder-cmp--bid-history">
                <h5 className="cmp__header">{t('biddingArea.bidHistory')}</h5>

                <div className="cmp__body">
                    {
                        bidsHistory && bidsHistory.length > 0 &&

                        <div className="bid-history__scrollable-list">
                            {
                                [ ... bidsHistory ] // clone Array so we do not mutate with .reverse()
                                    .reverse()
                                    .map((bid, index) => {
                                        return (
                                            <BiddingHistoryListItem
                                                key={[bid.value, bid.overridden || '0'].join('_')}
                                                bid={bid}
                                                isHighestBid={index === 0}
                                                isMyBid={bid.userId === myUserId}
                                                t={t}
                                            />
                                        )
                                    })

                            }
                        </div>
                    }
                </div>

            </div>

        </div>
    )
}


export default connect(({activeWebcast}: { activeWebcast: ReduxActiveWebcastSubStateType }) => {
    return {
        bidsHistory: activeWebcast.webcastCurrentRoundBidding.bidsHistory,
    };
})(BidderBidHistoryCmp);

